import Button from './regular';
import IconBtn from './icon';
import RectangleBtn from './rectangle';
import SquareBtn from './square';
import TabBtn from './tab';
import TextBtn from './text';
import VerticalBtn from './vertical';
Button.Icon = IconBtn;
Button.Rectangle = RectangleBtn;
Button.Square = SquareBtn;
Button.Tab = TabBtn;
Button.Text = TextBtn;
Button.Vertical = VerticalBtn;
export default Button;
//# sourceMappingURL=index.js.map